import React from "react";

import SortLabel from "components/SortLabel";
import { IHeaderCell } from "../../types";

import useStyles from "./styles";

type Props = Pick<IHeaderCell, "title" | "sortableCell" | "highlighted">;

const HeaderCellContent = (props: Props) => {
  const { title, sortableCell, highlighted } = props;

  const classes = useStyles();

  if (sortableCell) {
    const { name, sortOrder, sortHandler } = sortableCell;

    return (
      <SortLabel
        className={highlighted && classes.greenLabel}
        columnName={name}
        sortDirection={sortOrder}
        onSort={sortHandler}
      >
        {title}
      </SortLabel>
    );
  }

  return <>{title}</>;
};

export default React.memo(HeaderCellContent);
